import React, { useState } from "react";
import { Trucker } from "./Trucker";
import { FaAngleDown, FaPen, FaTrash } from "react-icons/fa";

export const RenderTruckers = ({ truckers = [], sendTruckers, accounts = [] }) => {
  const [editingTrucker, setEditingTrucker] = useState(null); // trucker object or 'new'
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleNewTrucker = (e) => {
    e?.preventDefault();
    const newObj = {
      id: Math.floor(Math.random() * 100000),
      name: "",
      phone: "",
      trucker_emails: [{ email: "", cc_emails: [] }],
      accounts: accounts.map((a) => (typeof a === "object" ? a.account_no : a)),
      isNew: true,
    };
    setEditingTrucker(newObj);
    setIsModalOpen(true);
  };

  const handleEditClick = (trucker) => {
    setEditingTrucker({ ...trucker });
    setIsModalOpen(true);
  };

  const handleUpdateTrucker = (updatedObj) => {
    let aux = [...truckers];
    const index = aux.findIndex((t) => t.id === updatedObj.id);
    if (index !== -1) {
      aux[index] = updatedObj;
    } else {
      aux.push(updatedObj);
    }
    sendTruckers(aux);
    setIsModalOpen(false);
    setEditingTrucker(null);
  };

  const handleDeleteTrucker = (id) => {
    let aux = truckers.filter((t) => t.id !== id);
    sendTruckers(aux);
  };

  return (
    <div className="multiform truckers">
      <div className="tab-header">
        <h3 className="section-title personal">Truckers</h3>
        <button className="new-trucker" type="button" onClick={handleNewTrucker}>
          <p>New Trucker</p>
        </button>
      </div>

      <div className="divisor"></div>

      <div className="table-container truckers-table-wrapper">
        <table className="settings-table">
          <thead>
            <tr>
              <th>
                Name <FaAngleDown className="sort-icon" />
              </th>
              <th>
                Main Email Address <FaAngleDown className="sort-icon" />
              </th>
              <th>
                CC Email Addresses <FaAngleDown className="sort-icon" />
              </th>
              <th>
                Account <FaAngleDown className="sort-icon" />
              </th>
              <th className="actions-col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {truckers && truckers.length > 0 ? (
              truckers.map((trucker, i) => {
                const mainEmail = trucker?.trucker_emails?.[0]?.email || "-";
                const ccEmails = trucker?.trucker_emails?.[0]?.cc_emails || [];
                const firstCc = ccEmails.slice(0, 2).join(", ");
                const remainingCcCount = ccEmails.length > 2 ? ccEmails.length - 2 : 0;
                
                const accountDisplay = Array.isArray(trucker?.accounts) && trucker.accounts.length > 0
                  ? trucker.accounts.join(", ")
                  : accounts.length > 0
                  ? accounts.map(a => typeof a === 'object' ? a.account_no : a).join(", ")
                  : "-";

                return (
                  <tr key={trucker.id || i}>
                    <td className="font-bold">{trucker.name || "—"}</td>
                    <td>{mainEmail}</td>
                    <td>
                      {firstCc ? (
                        <span>
                          {firstCc}
                          {remainingCcCount > 0 && (
                            <span className="badge-more">+{remainingCcCount}</span>
                          )}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>{accountDisplay}</td>
                    <td className="actions-cell">
                      <button
                        type="button"
                        className="action-btn edit-btn"
                        onClick={() => handleEditClick(trucker)}
                        title="Edit Trucker"
                      >
                        <FaPen />
                      </button>
                      <button
                        type="button"
                        className="action-btn delete-btn"
                        onClick={() => handleDeleteTrucker(trucker.id)}
                        title="Delete Trucker"
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="5" className="empty-table">
                  No truckers found. Click "New Trucker" to add one.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isModalOpen && editingTrucker && (
        <Trucker
          truckerInfo={editingTrucker}
          accounts={accounts}
          onSave={handleUpdateTrucker}
          onClose={() => {
            setIsModalOpen(false);
            setEditingTrucker(null);
          }}
        />
      )}
    </div>
  );
};
